module.exports = __webpack_public_path__ + "img/simulator_logo_green.c7e9feec.svg";